/*
  Asset: metafield-filters.js
  Purpose: Small enhancement for Shopify native Search & Discovery filters.
  Notes:
  - Filtering still works without this file because each checkbox submits the form inline.
  - This script avoids double-binding and allows future enhancement if needed.
*/

(function () {
  'use strict';

  function initMetafieldFilters() {
    var forms = document.querySelectorAll('[data-facets-form]');

    forms.forEach(function (form) {
      if (form.dataset.metafieldFiltersReady === 'true') {
        return;
      }

      form.dataset.metafieldFiltersReady = 'true';

      form.addEventListener('change', function (event) {
        var target = event.target;

        if (target && target.matches('input[type="checkbox"]')) {
          form.submit();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMetafieldFilters);
  } else {
    initMetafieldFilters();
  }

  document.addEventListener('shopify:section:load', initMetafieldFilters);
}());
